import {Injectable, Injector} from '@angular/core';
import {PermissionService} from '@shared/service/permission.service';
import { FluxModel } from '@app/shared/utilities/flux.model';
import { FluxAuthorityStore } from '@authority/authority-shared/services/flux/flux.authority.store';
import { EAction } from '@authority/authority-shared/services/flux/flux.actions.model';


const ACTION_LIST = [
  EAction.GET_DOSSIER,
  EAction.SET_DOSSIER,
  EAction.GET_WORKING_LIST,
  EAction.SET_WORKING_LIST,
  EAction.GET_QUOTATION,
  EAction.SET_QUOTATION,
];

@Injectable()
export class FluxAuthorityService extends FluxModel {

  /**
   *  Il servizio ha lo scopo di centralizzare i dati relativi ad Authority
   * 
   * 
   *  DossierModel:
   *  L'intervento viene consultato uno per volta
   * 
   *  WorkingModel
   *  Diverse pratiche sono associate all'intevento (Meccanica, Carrozzeria o Amministrazione)
   *  Tranne per mobility dove l'associazione è praticamente 1:1
   * 
   *  QuotationModel
   *  Il preventivo è associato 1:1 con la Pratica, anche se nei model non è stato collegato
   * 
   * 
   *  TODO
   *  Bisogna trovare un modo per collegare tutte le entità
   *  Prendere in condiserazione un set di strutture dati parallele...
   */ 

  private store: FluxAuthorityStore;

	constructor(
    protected injector: Injector,
    public permissionService: PermissionService,
  ) {
    super(ACTION_LIST);

    // TODO
    // impostare un singleton
    // dev'essere un'entità separata
    this.store = new FluxAuthorityStore();
	}

  /**
   * invoca una ACTION verso flux e Aggiorna lo stato generale
   * è un metodo custom e in futuro andrà 
   * ereditato per ogni sottoclasse appartenente al modulo
   * 
	 * @param {string} action
	 * @param {any} payload
   */ 
  public dispatch(action: string, payload?: any): any {

    if (action === EAction.GET_DOSSIER) {
      return this.store.getDossier();
    }
    
    if (action === EAction.SET_DOSSIER) {
      if (payload) {
        this.store.setDossier(payload);
        // si comunica il dato aggiornato a tutti i component
        this.eventDispatcher(EAction.GET_DOSSIER);
      }
      return;
    }

    if (action === EAction.GET_WORKING_LIST) {
      return this.store.getWorkingList();
    } 

    if (action === EAction.SET_WORKING_LIST) {
      if (payload) {
        this.store.setWorkingList(payload);
        // si comunica il dato aggiornato a tutti i component
        this.eventDispatcher(EAction.GET_WORKING_LIST);
      }
      return;
    } 
    
    if (action === EAction.GET_QUOTATION) {
      return this.store.getQuotationList();
    }
    
    if (action === EAction.SET_QUOTATION) {
      if (payload) {
        this.store.setQuotationList(payload);
        
        // si comunica il dato aggiornato a tutti i component
        this.eventDispatcher(EAction.GET_QUOTATION);
        
        // il preventivo è un campo interno alla pratica
        // di conseguenza i component usano questo collegaamento
        // sono in attesa del preventivo tramite la pratica
        this.eventDispatcher(EAction.GET_WORKING_LIST);
      }
      return;
    }
  }
}
